<template>
  <div class="col-xl-12">
    <div class="appointment">
      <!-- <div class="card invoice-payments-card"> -->
      <div
        class="card invoice-payments-card"
        :class="{
          'no-recent-payments':
            !loading1 && !loading2 && !error && !invoices.length,
        }"
      >
        <div class="card-header card-no-border">
          <div class="header-top">
            <div class="d-flex align-items-center">
              <h5 class="m-0">INVOICES AND PAYMENTS</h5>
              <!-- View Invoices on the Map Button -->
              <button
                v-if="selectedDistributor && invoices.length > 0"
                class="btn map-btn me-2"
                @click="showMapPopup = true"
                title="View on Map"
              >
                <i class="fas fa-map-marker-alt"></i>
              </button>

              <!-- Invoice Map Modal Component -->
              <InvoiceMapModal
                v-if="showMapPopup"
                :profileId="selectedDistributor"
                @close-modal="showMapPopup = false"
              />
            </div>

            <div class="d-flex align-items-center">
              <span
                v-if="loading1"
                class="spinner-border spinner-border-sm"
                role="status"
                aria-hidden="true"
              ></span>
              <span v-else class="current-month">{{
                currentYearAndMonth.toUpperCase()
              }}</span>
            </div>
          </div>
          <br />
          <!-- <div>
            <select
              v-model="selectedDistributor"
              class="form-select me-2"
              @focus="lazyLoadDistributors"
            >
              <option value="">All Distributors</option>
              <option
                v-for="distributor in distributors"
                :key="distributor.profile_id"
                :value="distributor.profile_id"
              >
                {{ distributor.name }}
              </option>
            </select>
          </div> -->
          <div class="invoice-filter-row">
            <select
              v-model="selectedDistributor"
              class="form-select invoice-distributor-select"
              @focus="lazyLoadDistributors"
            >
              <option value="">All Distributors</option>
              <option
                v-for="distributor in distributors"
                :key="distributor.profile_id"
                :value="distributor.profile_id"
              >
                {{ distributor.name }}
              </option>
            </select>

            <router-link
              class="btn btn-sm view-details-btn"
              to="/invoice-summary-report"
            >
              View Details
            </router-link>
          </div>

          <!-- Summary Boxes -->
          <div
            v-if="!loading1 && !loading2 && !error"
            class="invoice-summary-grid"
          >
            <div class="invoice-summary-card summary-blue">
              <div class="summary-title">Total Invoices</div>
              <div class="summary-value">
                Rs. {{ formatCurrency(totals.total_net) }}
              </div>
            </div>

            <div class="invoice-summary-card summary-green">
              <div class="summary-title">Total Collection</div>
              <div class="summary-value">
                Rs. {{ formatCurrency(totals.total_paid) }}
              </div>
            </div>

            <div class="invoice-summary-card summary-red">
              <div class="summary-title">Total Due Payments</div>
              <div class="summary-value">
                Rs. {{ formatCurrency(totals.total_due) }}
              </div>
            </div>
          </div>
        </div>

        <div class="card-body" :class="loading2 ? 'loading-center' : 'pt-0'">
          <div class="appointment-table">
            <!-- Loading spinner -->
            <div v-if="loading2" class="spinner-container">
              <div class="spinner"></div>
            </div>

            <!-- Error Message -->
            <div v-else-if="error" class="error-container">
              <img
                src="../../../../assets/vectors/data_not_found.png"
                alt="Error"
                class="error-image"
              />
              <p class="error-message">{{ error }}</p>
            </div>

            <!-- Empty State
            <div v-else-if="!invoices.length" class="invoice-empty-state">
              <div class="empty-icon">
                <i class="fa fa-file-invoice"></i>
              </div>

              <h6>No invoices found</h6>

              <p>
                There are no invoice payment records available for the selected
                distributor/month.
              </p>
            </div> -->

            <!-- Empty State -->
            <div
              v-else-if="!invoices.length"
              class="invoice-empty-state no-recent-payment-state"
            >
              <div class="empty-icon">
                <i class="fa fa-receipt"></i>
              </div>

              <h6>No recent payments</h6>

              <p>
                Recent payment records are not available for the selected
                distributor/month. Summary totals are still shown above.
              </p>
            </div>

            <!-- Invoice Cards -->
            <div v-else class="invoice-list">
              <div class="invoice-list-scroll">
                <div
                  v-for="item in invoices"
                  :key="item.id"
                  class="invoice-row-card"
                  :class="{ cancelled: item.isCancel }"
                >
                  <div class="invoice-avatar">
                    {{ getInitials(item.dealerName) }}
                  </div>

                  <div class="invoice-main">
                    <div class="invoice-title-row">
                      <div>
                        <h6>{{ item.dealerName }}</h6>
                        <p>{{ item.invoiceNo }}</p>
                      </div>

                      <!-- <span
                        v-if="item.isCancel"
                        class="invoice-status cancelled-badge"
                      >
                        Cancelled
                      </span>
                      <span v-else class="invoice-status active-badge">
                        Active
                      </span> -->
                    </div>

                    <div class="invoice-meta-grid">
                      <div class="invoice-meta-box">
                        <span class="meta-label">Invoice Amount</span>
                        <span class="meta-value">
                          Rs. {{ formatCurrency(item.netTotal) }}
                        </span>
                      </div>

                      <div class="invoice-meta-box due">
                        <span class="meta-label">Due Amount</span>
                        <span class="meta-value">
                          Rs. {{ formatCurrency(item.dueAmount) }}
                        </span>
                      </div>

                      <div class="invoice-meta-box date">
                        <span class="meta-label">Date</span>
                        <span class="meta-value">
                          {{ item.createdAt }}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- <router-link class="see-more" to="/invoice-summary-report">
                See More
              </router-link> -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  fetchDistributors,
  fetchInvoiceAndPayments,
} from "@/services/dataService";
import InvoiceMapModal from "@/pages/Modal/maps/invoiceMapModal.vue";

export default {
  components: {
    InvoiceMapModal,
  },

  data() {
    return {
      //Get the API access token from the local storage
      token: localStorage.getItem("token_set"),

      //Get the user profile id from the local storage
      profileId: localStorage.getItem("profile_id"),

      distributors: [],
      selectedDistributor: "",
      invoices: [],
      totals: {
        total_net: 0,
        total_paid: 0,
        total_due: 0,
      },
      loading1: false,
      loading2: false,
      error: null,
      currentYearAndMonth: this.getCurrentYearAndMonth(),

      //Modal state
      showMapPopup: false,

      // Scroll navigation states
      showLeftBtn: false,
      showRightBtn: false,
    };
  },

  mounted() {
    this.fetchInvoicesAndPayments("");
    window.addEventListener("resize", this.updateScrollButtons);
  },

  beforeUnmount() {
    window.removeEventListener("resize", this.updateScrollButtons);
  },

  watch: {
    selectedDistributor(newVal) {
      if (newVal === "") {
        this.fetchInvoicesAndPayments(""); // Empty string for "All Distributors"
      } else {
        this.fetchInvoicesAndPayments(newVal); // pass profile_id
      }
    },
  },

  methods: {
    // ADD this method
    async lazyLoadDistributors() {
      if (this.distributorsLoaded) return;
      await this.fetchDistributorsList();
      this.distributorsLoaded = true;
    },
    //Method to get the initials from the distributor name
    getInitials(name) {
      if (!name) return "NA"; // Return "NA" if name is null/undefined/empty

      const names = name.trim().split(" ");
      const firstInitial = names[0] ? names[0][0].toUpperCase() : "";
      const lastInitial =
        names.length > 1 ? names[names.length - 1][0].toUpperCase() : "";
      return `${firstInitial}${lastInitial}` || "NA";
    },

    //Get the current year and month
    getCurrentYearAndMonth() {
      const now = new Date();
      const year = now.getFullYear();
      const month = now.toLocaleString("default", { month: "long" });
      return `${year} ${month}`;
    },

    //Format currency with thousand separators and two decimal places
    formatCurrency(amount) {
      const num = parseFloat(amount);
      return isNaN(num)
        ? "0.00"
        : num.toLocaleString("en-US", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          });
    },

    //Fetch Distributors List
    async fetchDistributorsList() {
      try {
        this.loading1 = true;
        this.distributors = [];
        const response = await fetchDistributors(this.profileId, this.token);
        this.distributors = response.data.data;
      } catch (e) {
        console.log("error", e);
      } finally {
        this.loading1 = false;
      }
    },

    //Fetch Invoices and Payments
    async fetchInvoicesAndPayments(distributorId = "") {
      try {
        this.loading2 = true;
        this.invoices = [];
        this.totals = {
          total_net: 0,
          total_paid: 0,
          total_due: 0,
        };
        this.error = null;

        //Pass the parameters to the API payload
        const payload = {
          distributor_id: this.selectedDistributor,
        };

        const response = await fetchInvoiceAndPayments(payload, this.token);

        if (response.data.status === "success") {
          const invoiceList = Array.isArray(response.data.invoices)
            ? response.data.invoices
            : [];

          this.invoices = invoiceList.slice(0, 5).map((invoice) => {
            const netTotal = parseFloat(invoice.net_total) || 0;
            const paidAmount = parseFloat(invoice.paid_amount) || 0;

            return {
              id: invoice.id,
              invoiceNo: invoice.invoices_no || "N/A",
              netTotal,
              isCancel: String(invoice.is_cancel) === "1",
              createdAt: invoice.created_at || "N/A",
              dealerName: invoice.dealer_name || "Unknown dealer",
              distributor: invoice.distributor || "Unknown Distributor",
              paidAmount,
              dueAmount: netTotal - paidAmount,
            };
          });

          // Set totals from API response
          if (response.data.totals && response.data.totals.length > 0) {
            this.totals = {
              total_net: parseFloat(response.data.totals[0].total_net) || 0,
              total_paid: parseFloat(response.data.totals[0].total_paid) || 0,
              total_due: parseFloat(response.data.totals[0].total_due) || 0,
            };
          }

          this.$nextTick(() => {
            this.updateScrollButtons();
          });
        } else {
          this.error = response.data.message;
        }
      } catch (e) {
        this.error = "Something went wrong";
      } finally {
        this.loading2 = false;
      }
    },

    // Method to handle scrolling of summary boxes
    scrollSummary(direction) {
      const container = this.$refs.summaryBoxes;
      if (!container) return;

      const scrollAmount = container.clientWidth * 0.75;
      if (direction === "left") {
        container.scrollLeft -= scrollAmount;
      } else {
        container.scrollLeft += scrollAmount;
      }

      setTimeout(() => {
        this.updateScrollButtons();
      }, 300);
    },

    // Method to update scroll button visibilities
    updateScrollButtons() {
      const container = this.$refs.summaryBoxes;
      if (container) {
        // Checking with a small threshold to avoid precision issues
        this.showLeftBtn = container.scrollLeft > 5;
        this.showRightBtn =
          container.scrollLeft + container.clientWidth <
          container.scrollWidth - 5;
      } else {
        this.showLeftBtn = false;
        this.showRightBtn = false;
      }
    },
  },
};
</script>

<style scoped>
.appointment {
  width: 100%;
  height: 100%;
  min-width: 0;
  display: flex;
}

.invoice-payments-card {
  width: 100%;
  height: 100%;
  min-width: 0;
  display: flex;
  flex-direction: column;
  border-radius: 15px;
  overflow: hidden;
}

.invoice-payments-card .card-header {
  flex-shrink: 0;
  padding: 10px 12px 8px !important;
}

.invoice-payments-card .card-body {
  flex: 1;
  min-height: 0;
  padding: 8px 10px 10px !important;
  display: flex;
  flex-direction: column;
}

.header-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  flex-wrap: wrap;
}

.header-top h5 {
  font-size: 13.5px !important;
  font-weight: 800;
  color: #0f172a;
  letter-spacing: -0.01em;
  line-height: 1.2;
}

.current-month {
  color: #475569;
  font-size: 11.5px;
  font-weight: 600;
  letter-spacing: 0.06em;
}

.form-select {
  height: 32px;
  min-height: 32px;
  width: 100%;
  padding: 4px 28px 4px 10px;
  border: 1px solid #e1e7ef;
  border-radius: 9px;
  background-color: #ffffff;
  color: #1f2937;
  font-size: 12px;
  font-weight: 600;
  box-shadow: none;
}

.form-select:focus {
  border-color: #198754;
  box-shadow: 0 0 0 3px rgba(25, 135, 84, 0.1);
}

.invoice-summary-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 9px;
  margin-top: 12px;
}

.invoice-summary-card {
  min-width: 0;
  min-height: 74px;
  border-radius: 12px;
  padding: 12px 10px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 6px;
  text-align: center;
  border: 1px solid rgba(15, 23, 42, 0.05);
  box-shadow: 0 6px 16px rgba(15, 23, 42, 0.045);
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.invoice-summary-card:hover {
  transform: translateY(-1px);
  box-shadow: 0 10px 20px rgba(15, 23, 42, 0.07);
}

.summary-title {
  font-size: 11.5px;
  font-weight: 700;
  color: #475569;
  line-height: 1.2;
  white-space: normal;
}

.summary-value {
  font-size: 13px;
  font-weight: 800;
  color: #0f172a;
  line-height: 1.2;
  overflow-wrap: anywhere;
}

.summary-blue {
  background: linear-gradient(135deg, #eef9ff 0%, #d9f0f8 100%);
}

.summary-green {
  background: linear-gradient(135deg, #edf9f2 0%, #d9eee3 100%);
}

.summary-green .summary-title {
  color: #087f45;
}

.summary-red {
  background: linear-gradient(135deg, #fff1f2 0%, #f8d8d8 100%);
}

.summary-red .summary-title {
  color: #dc2626;
}

.appointment-table {
  flex: 1;
  min-height: 0;
  width: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.appointment-table::-webkit-scrollbar {
  width: 3px;
  height: 3px;
}

.appointment-table::-webkit-scrollbar-track {
  background: transparent;
}

.appointment-table::-webkit-scrollbar-thumb {
  background: rgba(148, 163, 184, 0.42);
  border-radius: 999px;
}

.appointment-table::-webkit-scrollbar-thumb:hover {
  background: rgba(100, 116, 139, 0.65);
}

/* Empty state */
.invoice-empty-state {
  min-height: 245px;
  border: 1px dashed #dbe3ef;
  border-radius: 14px;
  background: radial-gradient(
      circle at top,
      rgba(25, 135, 84, 0.08),
      transparent 34%
    ),
    linear-gradient(180deg, #ffffff 0%, #f8fafc 100%);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 7px;
  text-align: center;
  padding: 22px 18px;
}

.empty-icon {
  width: 46px;
  height: 46px;
  border-radius: 16px;
  background: #ecfdf5;
  color: #198754;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  box-shadow: 0 8px 18px rgba(25, 135, 84, 0.12);
}

.invoice-empty-state h6 {
  margin: 6px 0 0;
  font-size: 13px;
  font-weight: 850;
  color: #0f172a;
}

.invoice-empty-state p {
  margin: 0;
  max-width: 330px;
  font-size: 11.5px;
  font-weight: 550;
  color: #64748b;
  line-height: 1.45;
}

/* Invoice list cards */
.invoice-list {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
}


.invoice-list-scroll {
  max-height: 370px; /* around 4 payment cards */
  overflow-y: auto;
  overflow-x: hidden;
  padding-right: 4px;
  margin-right: -2px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  scroll-behavior: smooth;
  overscroll-behavior: contain;

  /* Firefox */
  scrollbar-width: thin;
  scrollbar-color: rgba(100, 116, 139, 0.72) transparent;
}

.invoice-list-scroll::-webkit-scrollbar {
  width: 6px;
}

.invoice-list-scroll::-webkit-scrollbar-track {
  background: transparent;
}

.invoice-list-scroll::-webkit-scrollbar-thumb {
  background: linear-gradient(180deg, #94a3b8 0%, #64748b 100%);
  border-radius: 999px;
  border: 1px solid #ffffff;
}


.invoice-list-scroll::-webkit-scrollbar-thumb:hover {
  background: linear-gradient(180deg, #64748b 0%, #475569 100%);
}

.invoice-row-card {
  display: grid;
  grid-template-columns: 38px minmax(0, 1fr);
  gap: 9px;
  align-items: flex-start;
  padding: 9px 10px;
  border: 1px solid #e8edf4;
  border-radius: 13px;
  background: linear-gradient(180deg, #ffffff 0%, #fbfdff 100%);
  box-shadow: 0 5px 14px rgba(15, 23, 42, 0.035);
  transition: all 0.2s ease;
}

.invoice-row-card:hover {
  transform: translateY(-1px);
  border-color: #dbe3ef;
  box-shadow: 0 9px 20px rgba(15, 23, 42, 0.065);
}

.invoice-row-card.cancelled {
  background: linear-gradient(180deg, #ffffff 0%, #fff7f7 100%);
}

.invoice-avatar {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: linear-gradient(135deg, #198754 0%, #087f45 100%);
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 11px;
  font-weight: 850;
  text-transform: uppercase;
  box-shadow: 0 7px 16px rgba(25, 135, 84, 0.18);
}

.invoice-main {
  min-width: 0;
}

.invoice-title-row {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 8px;
  min-width: 0;
}

.invoice-title-row h6 {
  margin: 0;
  color: #111827;
  font-size: 12.5px;
  font-weight: 850;
  line-height: 1.25;
  overflow-wrap: anywhere;
}

.invoice-title-row p {
  margin: 2px 0 0;
  color: #64748b;
  font-size: 11.5px;
  font-weight: 700;
  line-height: 1.2;
  overflow-wrap: anywhere;
}

.invoice-status {
  flex-shrink: 0;
  height: 21px;
  padding: 3px 8px;
  border-radius: 999px;
  font-size: 10px;
  font-weight: 800;
  line-height: 1.2;
}

.active-badge {
  background: #ecfdf5;
  color: #087f45;
  border: 1px solid #bbf7d0;
}

.cancelled-badge {
  background: #fff1f2;
  color: #dc2626;
  border: 1px solid #fecdd3;
}

.invoice-meta-grid {
  margin-top: 8px;
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 7px;
}

.invoice-meta-box {
  min-width: 0;
  padding: 7px 8px;
  border-radius: 10px;
  background: #f8fafc;
  border: 1px solid #eef2f7;
}

.invoice-meta-box.due {
  background: #fff7f7;
  border-color: #ffe1e1;
}

.invoice-meta-box.date {
  background: #f8fafc;
}

.meta-label {
  display: block;
  color: #94a3b8;
  font-size: 10px;
  font-weight: 750;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  line-height: 1.2;
}

.meta-value {
  display: block;
  margin-top: 3px;
  color: #0f172a;
  font-size: 11.5px;
  font-weight: 850;
  line-height: 1.25;
  overflow-wrap: anywhere;
}

.invoice-meta-box.due .meta-value {
  color: #ef233c;
}

.see-more {
  display: inline-flex;
  align-self: flex-start;
  margin-top: 2px;
  color: #087f45;
  font-size: 12px;
  font-weight: 850;
  text-decoration: none;
}

.see-more:hover {
  color: #064e3b;
}

.see-more:hover {
  color: #064e3b;
}

.map-btn {
  margin-left: 8px;
  border: 1px solid #e1e7ef;
  background-color: #ffffff;
  color: #475569;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 29px;
  height: 29px;
  padding: 0;
  border-radius: 9px;
  transition: all 0.2s ease;
}

.map-btn:hover {
  border-color: #198754;
  background-color: #ecfdf5;
  color: #198754;
  transform: translateY(-1px);
}

.spinner-container {
  flex: 1;
  min-height: 210px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.spinner {
  border: 3px solid rgba(25, 135, 84, 0.12);
  border-top: 3px solid #198754;
  border-radius: 50%;
  width: 30px;
  height: 30px;
  animation: spin 0.8s linear infinite;
}

.loading-center {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 260px;
}

.error-container {
  flex: 1;
  min-height: 210px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 6px;
  text-align: center;
}

.error-image {
  max-width: 120px;
  display: block;
  margin: 0 auto;
  opacity: 0.9;
}

.error-message {
  font-size: 12px;
  font-weight: 700;
  color: #198754;
  margin: 0;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

@media (max-width: 1399px) {
  .invoice-summary-grid {
    gap: 8px;
  }

  .invoice-summary-card {
    min-height: 68px;
    padding: 10px 8px;
  }

  .summary-value {
    font-size: 12.5px;
  }
}

@media (max-width: 1199px) {
  .invoice-summary-grid {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .img-content-box h6 {
    max-width: 150px;
  }
}

@media (max-width: 768px) {
  .invoice-payments-card .card-header {
    padding: 9px 10px 7px !important;
  }

  .invoice-payments-card .card-body {
    padding: 7px 8px 9px !important;
  }

  .header-top h5 {
    font-size: 13px !important;
  }

  .invoice-summary-grid {
    grid-template-columns: 1fr;
    gap: 7px;
    margin-top: 9px;
  }

  .invoice-summary-card {
    min-height: 58px;
    align-items: flex-start;
    text-align: left;
    padding: 9px 10px;
  }

  .summary-title {
    font-size: 11px;
  }

  .summary-value {
    font-size: 12.5px;
  }

  .table td {
    padding: 6px 7px !important;
  }

  .avatar {
    width: 30px;
    height: 30px;
    min-width: 30px;
    font-size: 10.5px;
  }

  .img-content-box h6,
  .img-content-box p,
  .text-end p {
    font-size: 11px !important;
  }
}

@media (max-width: 1399px) {
  .invoice-list-scroll {
    max-height: 390px;
  }
}

@media (max-width: 480px) {
  .header-top {
    align-items: flex-start;
  }

  .form-select {
    height: 31px;
    min-height: 31px;
    font-size: 11.5px;
  }

  .invoice-list-scroll {
    max-height: 360px;
  }
}

/* No recent payment state: keep top 3 boxes compact */
.invoice-payments-card.no-recent-payments .card-header {
  flex: 0 0 auto !important;
  height: auto !important;
  min-height: 0 !important;
}

.invoice-payments-card.no-recent-payments .invoice-summary-grid {
  height: auto !important;
  min-height: 0 !important;
  align-items: start !important;
  grid-auto-rows: min-content !important;
}

.invoice-payments-card.no-recent-payments .invoice-summary-card {
  height: 72px !important;
  min-height: 72px !important;
  max-height: 72px !important;
  align-self: start !important;
  justify-content: center !important;
  align-items: center !important;
  text-align: center !important;
  padding: 10px 9px !important;
}

.invoice-payments-card.no-recent-payments .card-body {
  flex: 1;
  min-height: 0;
  padding-top: 8px !important;
}

.invoice-payments-card.no-recent-payments .appointment-table {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  overflow: hidden;
}

/* Compact empty state under the 3 summary boxes */
.no-recent-payment-state {
  flex: 0 0 auto !important;
  height: 152px !important;
  min-height: 152px !important;
  max-height: 152px !important;
  margin-top: 0;
  border: 1px dashed #dbe3ef;
  border-radius: 14px;
  background: radial-gradient(
      circle at top,
      rgba(25, 135, 84, 0.08),
      transparent 34%
    ),
    linear-gradient(180deg, #ffffff 0%, #f8fafc 100%);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 6px;
  text-align: center;
  padding: 16px;
}

.no-recent-payment-state .empty-icon {
  width: 40px;
  height: 40px;
  border-radius: 14px;
  font-size: 17px;
}

.no-recent-payment-state h6 {
  margin: 4px 0 0;
  font-size: 13px;
  font-weight: 850;
  color: #0f172a;
}

.no-recent-payment-state p {
  margin: 0;
  max-width: 340px;
  font-size: 11.5px;
  font-weight: 550;
  color: #64748b;
  line-height: 1.4;
}

/* Mobile no recent payment layout */
@media (max-width: 768px) {
  .invoice-payments-card.no-recent-payments .invoice-summary-card {
    height: 58px !important;
    min-height: 58px !important;
    max-height: 58px !important;
    align-items: flex-start !important;
    text-align: left !important;
  }

  .no-recent-payment-state {
    height: 165px !important;
    min-height: 165px !important;
    max-height: 165px !important;
  }
}

.invoice-filter-row {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
}

.invoice-distributor-select {
  flex: 1;
  min-width: 0;
  margin-right: 0 !important;
}

.view-details-btn {
  height: 32px;
  min-width: 98px;
  padding: 6px 14px;
  border-radius: 9px;
  background: #000000;
  border: 1px solid #000000;
  color: #ffffff;
  font-size: 12px;
  font-weight: 800;
  line-height: 1;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  white-space: nowrap;
  text-decoration: none;
  transition: all 0.2s ease;
}

.view-details-btn:hover {
  background: #111827;
  border-color: #111827;
  color: #ffffff;
  transform: translateY(-1px);
}

@media (max-width: 480px) {
  .invoice-filter-row {
    flex-direction: column;
    align-items: stretch;
  }

  .view-details-btn {
    width: 100%;
  }
}
</style>
